var alertsCount;
jQuery(document).ready(function ($) {
  var rootURL = window.location.protocol + "//" + window.location.host;
  function countAlerts() {
    alertsCount = $('.alerts .alert').length;
  }

  //Splide init
  new Splide('.splide.alerts', {
    classes: {
      pagination: 'splide__pagination alerts-pagination',
      arrows: 'splide__arrows alert-nav',
      arrow: 'splide__arrow alert-arrow',
      prev: 'splide__arrow--prev alert-prev',
      next: 'splide__arrow--next alert-next',
    },
  }).mount();
  $('.splide.alerts').addClass('multiple');


  //Hide alert and set cookie
  $('.alerts__icon--close').click(function () {
    $('.alerts').remove();
    $('body').removeClass('alerts-enabled');
    localStorage.setItem('btnClicked', true);
  });

  //Check to see if alert has been closed. If so, keep hidden. If not, show.
  //TODO: Check to see if new alert has been added, and change localStorage to false
  $(document).ready(function () {
    var clicked = localStorage.getItem("btnClicked");
    if (clicked) {
      $('.alerts').remove();
    } else {
      $('.alerts').show();
    }
  });

  if ($('.alerts').length) {
    $('body').addClass('alerts-enabled');
  }

});